import React, { useState, useEffect } from 'react';
import { Helmet } from "react-helmet";
import { useHistory } from 'react-router-dom';
import analyticsService from 'services/analyticsService';
import useCompetitionEntryState from 'contexts/useCompetitionEntryContext';
import ActionBar from 'containers/ActionBar/ActionBar';
import Button from 'components/Button/Button';
import prizeList from 'utils/prizes';
import Prize from 'components/Prize/Prize';
import SettingsContext from 'contexts/SettingsContext';
import './PrizeSelection.scss';
import Carousel from 'components/Carousel/Carousel';
import Modal from 'components/Modal/Modal';
import ReactDOM from 'react-dom';
import FocusTrap from 'focus-trap-react';
import SummaryTsandCs from 'components/SummaryTsandCs/SummaryTsandCs';

export default () => {
  let competitionEntryState = useCompetitionEntryState();
  let history = useHistory();
  let [prize, setPrize] = useState(competitionEntryState.prize);
  let [showModal, setShowModal] = useState(false);
  let [showVideo, setShowVideo] = useState(false);
  let [videoSource, setVideoSource] = useState(null);
  let [videoSourceDesk, setVideoSourceDesk] = useState(null);
  let [selectedPrize, setSelectedPrize] = useState(null);
  let [settings, setSettings] = React.useContext(SettingsContext);

  useEffect(() => {
    const scrollToTop = () => {
      document.body.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    };
  
    scrollToTop();
  }, []);


  const onConfirm = (e, id) => {
    e.preventDefault(); 
    document.body.classList.remove("overflow-hidden-mediumdown");
    if (id !== null) {
      competitionEntryState.setPrize(id);
      setSettings({ ...settings, prize: id });
  
      analyticsService.logEvent("form", "PrizeSelection", {
        action: "SubmitSelectPrize",
        label: id
      });
      console.log("This Id was:", id);
      history.push("/registration");
    } else {
      console.log("This Id was:", id);
    }
  };
  
  const handleSelectedPrize = (selPrize) => {
    setPrize(selPrize);

    analyticsService.logEvent("form", "PrizeSelection", {
      action: "SelectPrize",
      label: selPrize.id
    });
  };

  const handleShowModal = (e, id) => {
    setSelectedPrize(prizeList.find(p => p.id === id));
    setShowModal(true);
  };

  const handleCloseModal = () => {
    document.body.classList.remove("overflow-hidden-mediumdown");
    setShowModal(false);
  };

  const handleShowVideo = (video, videoDesk) => {
    setVideoSource(video);
    setVideoSourceDesk(videoDesk);
    setShowVideo(true);
  };

  const handleCloseVideo = () => {
    setShowVideo(false);
    setVideoSource(null);
  };

  return <>
    <Helmet>
      <meta charSet="utf-8" />
      <title>Prize Selection | Cadbury FC - Game Changing Wins</title>
    </Helmet>
    <div className="layout">
      <section className="layout-general layout-general--full layout-wrapper overflowx-hidden">
        <div className="layout-container layout-container--center layout-container--wide prize-select">
          <h1 className="type-h2">Choose your Game Changer</h1>
          <div className="prize-select__intro">
            <p>Behind every one of our game changing players is a story of support</p>
            <p>Click on a player to chose who you’d like to meet, and learn more about their stories below.</p>
          </div>
          <form>
            <div className="prize-select__list">
              <div className='prize-select__nav prize-select__nav--gold'>
                <button type="button" className='swiper-button-prev'></button>
                <div className='swiper-pagination2'></div>
                <button type="button" className='swiper-button-next'></button>
              </div>

              <Carousel 
                className="prize-select__carousel"
                params={{
                  watchOverflow: true,
                  spaceBetween: 30,
                  slidesPerView: 1,
                  centeredSlides: false,
                  pagination: {
                    el: '.swiper-pagination2',
                    type: 'fraction'
                  },
                  navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                  },
                  runCallbacksOnInit: true,
                  slidesPerGroup: 1,

                  breakpoints: {
                    640: {
                      slidesPerView: 2,
                      spaceBetween: 0,
                      slidesPerGroup: 2,
                    },
                    992: {
                      slidesPerView: 3,
                      spaceBetween: 0,
                      slidesPerGroup: 3,
                    },
                    1400: {
                      slidesPerView: 4,
                      spaceBetween: 0,
                      slidesPerGroup: 4,
                    }
                  }
                }}
              >
                {
                  prizeList.map((p, index) => (
                    <>
                    <div
                    className="prize-badge-wrapper"
                    key={"prize-wrapper__" + index}
                    tabIndex="0"
                    role="button" 
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        const radioInput = document.getElementById(`prize_badge_${p.id}`); 
                        if (radioInput) {
                          radioInput.click(); 
                        }
                      }
                    }}
                    onClick={(e) => handleShowModal(e, p.id)} 
                  >
                      <Prize 
                        id={p.id}
                        tab={index + 1}
                        prize={p} 
                        model="prize"
                        selected={prize && prize.id === p.id} 
                        selectable 
                        onChange={(selected) => handleSelectedPrize(selected)}
                        onClick={(e) => handleShowModal(e, p.id)}
                        buttonTitle={"Choose " + p.title}
                      />
                    </div>
                    <a href="#" tabindex="0" onClick={() => handleShowVideo(p.video, p.videoDesk)} id="player-vid" className="prize-badge-wrapper__link">Watch {p.title}'s Story</a>
                    </>
                  ))
                }
              </Carousel>
            </div>
            <p>Prize draw will take place after 28/07/25</p>
          </form>
        </div>
      </section>
      <SummaryTsandCs   />
    </div>

    {showModal && selectedPrize && ReactDOM.createPortal(
      <Modal
        className={"modal--selection"}
        panel
        hideClose
        title="Confirm Your Player"
      >
        <p>You have chosen {selectedPrize.name}</p>
        <Button title="Confirm" onClick={(e) => onConfirm(e, selectedPrize.id)} />
        <Button className="button--secondary" title="Back" onClick={handleCloseModal} />
      </Modal>,
      document.body
    )}

    {showVideo && videoSource && ReactDOM.createPortal(
      <FocusTrap>
      <div className="prize-select__video">
        <div className="prize-select__video-content">
          <button tabindex="0" className="modal__close" onClick={handleCloseVideo}></button>
          <video autoPlay controls playsInline>
            <source src={videoSourceDesk} type="video/mp4" media="(min-width:640px)" />
            <source src={videoSource} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
      </FocusTrap>,
      document.body
    )}
  </>;
};
